import { render, staticRenderFns } from "./ProjectManagementArchiveColumnModal.vue?vue&type=template&id=2bc54877&"
import script from "./ProjectManagementArchiveColumnModal.vue?vue&type=script&lang=js&"
export * from "./ProjectManagementArchiveColumnModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports